<!-- 
    <div class="css-Campo_Default campo_default">
        <p class="css-Etiqueta etiqueta">{{descripcion_etiqueta}}</p>
        <div class="css-Campo_mensaje campo_mensaje">
            <input [id]="id" type="text" class="css-input_text_Campo input_text_campo" name="input_text_campo"
                placeholder="{{placeholder_input}}" [(ngModel)]="modelValue" (ngModelChange)="onInputChange($event)">
            <app-mensaje-error [mensaje_error]="mensaje_error"></app-mensaje-error>
        </div>
    </div> -->

<div class="css-campo_default-1 campo_default">
    <label *ngIf="descripcion_etiqueta" class="css-label_campo-1 label_campo">{{descripcion_etiqueta}}</label>
    <div class="css-agrupador_mensajes_input-1 agrupador_mensajes_input">
        <input [id]="id" type="text" placeholder="{{placeholder_input}}"
            [ngClass]="{'input_text_campo':true, 'input-disabled':disabled}" [(ngModel)]="modelValue"
            (ngModelChange)="onInputChange($event)" [disabled]="disabled">
        <div *ngIf="mensaje_ayuda" class="css-mensaje_ayuda_campo-1 mensaje_ayuda_campo">
            <p data-wcfid="texto_mensaje_ayuda_campo" class="css-texto_mensaje_ayuda_campo-1 texto_mensaje_ayuda_campo">
                {{mensaje_ayuda}}</p>
        </div>
        <div *ngIf="mensaje_error" class="css-mensaje_error_campo-1 mensaje_error_campo">
            <!-- Instance of sub-component comp-icon-mensaje-error -->
            <app-mensaje-error [mensaje_error]="mensaje_error"></app-mensaje-error>
        </div>
    </div>
</div>